import { Link } from 'react-router-dom';

export default function ContainerCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            准备好开始了吗？
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
            立即体验 PDF REST Container，让您的 PDF 处理更加简单高效
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link 
              to="/contact"
              className="bg-white text-teal-600 hover:bg-gray-50 px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-rocket-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              免费试用
            </Link>
            <Link 
              to="/contact"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-customer-service-2-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              联系销售
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <i className="ri-shield-check-line text-4xl mb-3 text-cyan-200"></i>
              <div className="text-sm text-white/80">企业级安全</div>
            </div>
            <div className="text-center">
              <i className="ri-customer-service-line text-4xl mb-3 text-cyan-200"></i>
              <div className="text-sm text-white/80">7×24 技术支持</div>
            </div>
            <div className="text-center">
              <i className="ri-refresh-line text-4xl mb-3 text-cyan-200"></i>
              <div className="text-sm text-white/80">持续更新升级</div>
            </div>
            <div className="text-center">
              <i className="ri-award-line text-4xl mb-3 text-cyan-200"></i>
              <div className="text-sm text-white/80">SLA 服务保障</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
